var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center"},[_c('el-color-picker',{attrs:{"color-format":"rgb","predefine":_vm.predefineColors},on:{"active-change":_vm.transformColor},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }